<template>
  <el-dialog
    :modal="isShowModal"
    :visible.sync="cyDialogCommon"
    custom-class="cy-dialog-common"
    :close-on-click-modal="false"
    :modal-append-to-body="isAppendBody"
    :show-close="false"
    :width="width"
    @open="handleOpen"
  >
    <div
      slot="title"
      class="cy-dialog-common_title"
    >
      <i class="icon icon-cy-idxDeail" />
      <span>{{ title }}</span>
      <i
        class="icon icon-cy-dialogClose"
        @click.stop.prevent="closeDialog"
      />
    </div>
    <div
      v-if="isShowFooter"
      slot="footer"
      class="dialog-footer"
      @click.stop.prevent
    >
      <el-button
        type="primary"
        @click="closeDialog"
      >
        取消
      </el-button>
      <el-button
        type="primary"
        class="save-btn"
        @click="handleSure"
      >
        确认
      </el-button>
    </div>
    <slot />
  </el-dialog>
</template>

<script>
import { toTopAnimation } from '@common/util.js'
export default {
  props: {
    title: {
      type: String,
      default: () => ''
    },
    icon: {
      type: String,
      default: () => ''
    },
    width: {
      type: String,
      default: () => '50%'
    },
    isShowFooter: {
      type: Boolean,
      default: () => false
    },
    isAppendBody: {
      type: Boolean,
      default: () => true
    },
    isTranCancel: {
      type: Boolean,
      default: () => false
    },
    isShowModal: {
      type: Boolean,
      default: () => true
    },
    isInitShow: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      cyDialogCommon: this.isInitShow
    }
  },
  methods: {
    closeDialog () {
      this.cyDialogCommon = false
      if (this.isTranCancel) {
        this.$emit('handleCancel')
      }
    },
    handleSure () {
      this.$emit('dialogSure')
    },
    handleOpen () {
      this.$nextTick(() => {
        toTopAnimation('.el-dialog__body')
      })
    }
  }
}
</script>

<style lang="scss">
.el-dialog.cy-dialog-common {
  margin-top: 0 !important;
  height: initial !important;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  .el-dialog__header {
    padding: 28px 30px;
    .cy-dialog-common_title {
      font-size: 15px;
    }
  }
  .el-dialog__body {
    padding: 0 30px 30px;
  }
  .el-dialog__footer {
    padding: 0;
    margin: 0 20px;
    .dialog-footer {
      text-align: left;
      border-top: 1px solid  #E6E6E6;
      padding-left: 20px;
      height: 57px;
      .el-button {
        width: 60px;
        height: 30px;
        padding: 0;
        color: #3273FF;
        font-size: 12px;
        background: #FFFFFF;
        border: 1px solid #C3D4F6;
        border-radius: 3px;
        margin: 10px 10px 0 0;
      }
      .save-btn {
        background: #3273FF;
        color: #fff;
        margin-right: 0;
      }
    }
  }
  .cy-dialog-common {
    &_title {
      display: flex;
      align-items: center;
      position: relative;
      .icon-cy-idxDeail {
        margin-right: 9px;
      }
      .icon-cy-dialogClose {
        position: absolute;
        right: 0;
        cursor: pointer;
      }
    }
  }
}
</style>
